import { render, staticRenderFns } from "./Gain2View.vue?vue&type=template&id=409693f9&scoped=true"
import script from "./Gain2View.vue?vue&type=script&lang=js"
export * from "./Gain2View.vue?vue&type=script&lang=js"
import style0 from "./Gain2View.vue?vue&type=style&index=0&id=409693f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "409693f9",
  null
  
)

export default component.exports